jQuery(document).ready(function($) {

    $('.home .orbit .orbit-bullets .button').on('click' , function(){
        window.location.href = $(this).attr('href');
    });




    $('#testimonial-slider').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        items: 1,
        navText: ["<i class='fa fa-chevron-left fa-2x'></i>", "<i class='fa fa-2x fa-chevron-right'></i>"],
        dots : true,
        navContainer: '#testimonial-slider-nav',
    });
    if (!$('body').hasClass('home')) {
        var sync1 = $("#sync1 .owl-carousel");
        var sync2 = $("#sync2 .owl-carousel");


        var slidesPerPage = 6; //globaly define number of elements per page
        var syncedSecondary = true;

        sync1.owlCarousel({
            items: 1,
            nav: true,
            autoplay: true,
            dots: false,
            loop: true,
            navText: ["<i class='fa fa-chevron-left fa-lg'></i>", "<i class='fa fa-lg fa-chevron-right'></i>"],
            navContainer: '#sync2-nav',
            responsiveRefreshRate: 200,
        }).on('changed.owl.carousel', syncPosition);

        sync2
            .on('initialized.owl.carousel', function () {
                var sync2height = $('#sync2').height();
                $('#sync2').css('margin-top', '-' + sync2height + 'px');

                sync2.find(".owl-item").eq(0).addClass("current");

            })
            .owlCarousel({
                items: slidesPerPage,
                false: true,
                nav: false,
                dots: false,
                autoplay: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 2,
                    },
                    600: {
                        items: 3,
                    },
                    1000: {
                        items: 4,
                    },
                    1330: {
                        items: slidesPerPage,
                    }
                },
                smartSpeed: 1000,
                slideBy: 1, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
                responsiveRefreshRate: 100
            }).on('changed.owl.carousel', syncPosition2);

        function syncPosition(el) {
            //if you set loop to false, you have to restore this next line
            //var current = el.item.index;

            //if you disable loop you have to comment this block
            var count = el.item.count - 1;
            var current = Math.round(el.item.index - (el.item.count / 2) - .5);

            if (current < 0) {
                current = count;
            }
            if (current > count) {
                current = 0;
            }

            //end block

            sync2
                .find(".owl-item")
                .removeClass("current")
                .eq(current)
                .addClass("current");
            var onscreen = sync2.find('.owl-item.active').length - 1;
            var start = sync2.find('.owl-item.active').first().index();
            var end = sync2.find('.owl-item.active').last().index();

            if (current > end) {
                sync2.data('owl.carousel').to(current, 100, true);
            }
            if (current < start) {
                sync2.data('owl.carousel').to(current - onscreen, 100, true);
            }
        }

        function syncPosition2(el) {
            if (syncedSecondary) {
                var number = el.item.index;
                sync1.data('owl.carousel').to(number, 100, true);
            }
        }

        sync2.on("click", ".owl-item", function (e) {
            e.preventDefault();
            var number = $(this).index();
            sync1.data('owl.carousel').to(number, 300, true);
        });
    }

});